import TypeaheadFieldComponent from './typeahead-field-component';

/***
 * A field that takes in a list of options and then renders a typeahead list populated by those options.
 */
const typeaheadField = angular
    .module('FacilityData.ClientEdit.FormFields.TypeaheadField', [])
    .component('typeaheadField', TypeaheadFieldComponent)
    .name;

export default typeaheadField;


// WEBPACK FOOTER //
// ./app/common/form-fields/typeahead-field/typeahead-field.js